import './App.css';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter as Router } from "react-router-dom";
import { pdfjs } from 'react-pdf';
import Site from './site/Site.jsx';
import { CustomerCartProvider} from './assetHire/CustomerCartContext.jsx';

// Set the workerSrc outside the App function
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url
).toString();

function App() {
  return (
    <>
      <CookiesProvider>
        <CustomerCartProvider>
        <Router>
          <Site />
        </Router>
        </CustomerCartProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
